import { createSlice } from "@reduxjs/toolkit";

export interface TimeLogInDetailModal {
  id: string | number | null;
  open: boolean;
  taskName: string;
  subTaskName: string;
  issueName: string;
  taskId: string | number;
  subTaskId: string | number;
  issueId: string | number;
  projectId: string | number;
  projectName: string;
  activeTab: string;
  selectedTimeLogDetails: any;
  onClose?: "openProjectModal";
  extra?: {
    createdAt?: string;
    totalWorkHoursInSec: number;
    billingType?: string;
    dailyLogHours?: string;
    timePeriod?: string;
    notes?: string;
  };
}

const initialState: { data: TimeLogInDetailModal } = {
  data: {
    id: null,
    open: false,
    taskName: "",
    subTaskName: "",
    issueName: "",
    taskId: "",
    subTaskId: "",
    issueId: "",
    projectId: "",
    projectName: "",
    selectedTimeLogDetails: null,
    extra: {
      createdAt: "",
      billingType: "",
      totalWorkHoursInSec: 0,
      dailyLogHours: "",
      timePeriod: "",
      notes: "",
    },

    activeTab: "activities",
    onClose: "openProjectModal",
  },
};

export const TimeLogInDetailModalSlice = createSlice({
  name: "TimeLogInDetailModalSlice",
  initialState,
  reducers: {
    updateTimeLogInDetailModalSlice(state, action) {
      state.data = { ...state.data, ...action.payload };
    },
    resetTimeLogInDetailModalSlice(state) {
      state.data = initialState.data;
    },
  },
});

export const {
  updateTimeLogInDetailModalSlice,
  resetTimeLogInDetailModalSlice,
} = TimeLogInDetailModalSlice.actions;

